import { z } from 'zod';
import { mediaSchema } from './media.js';

var OptionType = /* @__PURE__ */ ((OptionType2) => {
  OptionType2["TEXT"] = "text";
  OptionType2["IMAGE"] = "image";
  return OptionType2;
})(OptionType || {});
var Matcher = /* @__PURE__ */ ((Matcher2) => {
  Matcher2["EXACT"] = "exact";
  Matcher2["CONTAINS"] = "contains";
  return Matcher2;
})(Matcher || {});
const optionSchema = z.object({
  _id: z.string(),
  math: z.object({
    latex: z.array(z.string()),
    template: z.string().nullable()
  }).optional(),
  geometry: z.object({
    shape: z.enum(["circle", "rectangle", "polygon"]),
    height: z.number().optional(),
    width: z.number().optional(),
    points: z.array(
      z.object({
        x: z.number(),
        y: z.number()
      })
    )
  }).optional(),
  matcher: z.nativeEnum(Matcher).optional(),
  type: z.nativeEnum(OptionType),
  hasMath: z.boolean().default(false),
  media: z.array(mediaSchema),
  text: z.string()
});

export { OptionType, optionSchema };
